// removed by extract-text-webpack-plugin
module.exports = {"bg":"_3DMg7","base":"_3KnFV","sectionHeader":"_1fNgG","title":"_16Hv5","content":"_1JtgP","spinner":"_1zCoK","list":"laBUR","fieldset":"_3RJQq","form":"_3w8oI","group":"_24EnU","footer":"G5ezy"};


//////////////////
// WEBPACK FOOTER
// ./src/views/AccountsAndLoans/BankTransferDisplayForm.scss
// module id = 176
// module chunks = 0